export function normalizeSubjectName(name) {
    return String(name || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
}

function readinessRowRank(status) {
    if (status === "FormApproved") return 3;
    if (status === "AwaitingReview") return 2;
    return 1;
}

export function dedupeReadinessSubjects(rows) {
    if (!Array.isArray(rows)) return [];
    const byName = new Map();
    for (const row of rows) {
        const key = normalizeSubjectName(row.subName);
        if (!key) continue;
        const prev = byName.get(key);
        if (!prev || readinessRowRank(row.status) > readinessRowRank(prev.status)) {
            byName.set(key, row);
        }
    }
    return [...byName.values()].sort((a, b) =>
        String(a.subName || "").localeCompare(String(b.subName || "")),
    );
}

function queuePriority(status) {
    if (status === "Submitted") return 3;
    if (status === "FormApproved") return 2;
    return 1;
}

export function dedupeSubjectQueue(rows) {
    if (!Array.isArray(rows)) return [];
    const byName = new Map();
    for (const row of rows) {
        const key = normalizeSubjectName(row.subject?.subName || row.subjectId || row.id);
        if (!key) continue;
        const prev = byName.get(key);
        if (!prev || queuePriority(row.status) > queuePriority(prev.status)) {
            byName.set(key, row);
            continue;
        }
        if (queuePriority(row.status) === queuePriority(prev.status)) {
            const tRow = new Date(row.submittedAt || row.updatedAt || 0).getTime();
            const tPrev = new Date(prev.submittedAt || prev.updatedAt || 0).getTime();
            if (tRow > tPrev) byName.set(key, row);
        }
    }
    return [...byName.values()];
}

export function readinessStatusLabel(status) {
    if (status === "WithDirector") return "With director";
    if (status === "FormApproved") return "Accepted";
    if (status === "AwaitingReview") return "Awaiting your review";
    return "Not submitted";
}
